const _ = require('./enum');

const PaymentChannelCategory = {
  DISTANCE_SELLING: 'distance selling',
};

const paymentChannels = {
  [_.E_COMMERCE]: {
    id: _.E_COMMERCE,
    api_name: _.E_COMMERCE,
    code: 1,
    name: 'E-commerce',
    label: 'E-commerce',
    category: PaymentChannelCategory.DISTANCE_SELLING,
  },
  [_.MOTO]: {
    id: _.MOTO,
    api_name: _.MOTO,
    code: 2,
    name: 'Moto',
    label: 'Moto',
    category: PaymentChannelCategory.DISTANCE_SELLING,
  },
  [_.POS]: {
    id: _.POS,
    api_name: _.POS,
    code: 4,
    name: 'POS',
    label: 'POS',
    category: PaymentChannelCategory.DISTANCE_SELLING,
  },
  [_.RECURRING]: {
    id: _.RECURRING,
    api_name: _.RECURRING,
    code: 3,
    name: 'Recurring',
    label: 'Recurring',
    category: PaymentChannelCategory.DISTANCE_SELLING,
  },
};

module.exports = paymentChannels;
